const Minus = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2539 7.25195C14.668 7.25212 15.0039 7.58784 15.0039 8.00195C15.0035 8.41572 14.6677 8.75179 14.2539 8.75195H1.74609L1.66992 8.74805C1.29186 8.70977 0.996474 8.39002 0.996094 8.00195C0.996094 7.61357 1.29165 7.29419 1.66992 7.25586L1.74609 7.25195H14.2539Z"
        fill="#E8E8E8"
      />
    </svg>
  );
};

export default Minus;
